import { QueryClient } from '@tanstack/react-query';

/**
 * Below typical presigned logo URL lifetime (API default 3600s).
 * Used as both `staleTime` and `refetchInterval` so mounted observers refresh
 * the signed URL before it expires (staleTime alone does not refetch).
 */
export const COMPANY_LOGO_STALE_TIME_MS = 50 * 60 * 1000;

/** Super dashboard aggregate sections (tax reminders, upload entries, companies list). */
export const SUPER_DASHBOARD_STALE_TIME_MS = 2 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
